import * as React from "react"
import * as HAN from "models/headAndNeck";
import { AppContext } from "AppContext";
import { ActionTypes } from "reducer/actions";
import { Box, Button, Typography } from "@mui/material";
import { FilterContext } from "models/core/filter";
import Select from "react-select";
import { SideBySideButton } from "components/common/SideBySideOptions";
import { exportMdtPatients } from "models/mdt/worker";
import * as fileHelper from "helpers/fileHelper";
import Loader from "pages/shared/filterloader";

export function HeadAndNeckFilters() {
	const { state, dispatch } = React.useContext(AppContext);

	const addFilter: HAN.AddFilterFunc = async (key: keyof typeof HAN.DashboardFilterKeys, value: string | string[], context?: FilterContext, labelOverride?: string) => {
		const filteredDashboard = await HAN.computeChartData(HAN.addFilter(state.page.dashboard as HAN.IHeadAndNeckDashboard)(key, value, context, labelOverride)); // state = what the other filter function returns 
		dispatch({ type: ActionTypes.UserClickedOnChart, payload: filteredDashboard });
	}

	const removeFilter: HAN.RemoveFilterFunc = async (key: keyof typeof HAN.DashboardFilterKeys) => {

		const filteredDashboard = await HAN.computeChartData(HAN.removeFilter(state.page.dashboard as HAN.IHeadAndNeckDashboard, key));
		dispatch({ type: ActionTypes.UserClickedOnChart, payload: filteredDashboard });
	}

	if (state.page.loading)
		return <Loader />;

	const dataForFilters = state.page.dashboard.chartData as HAN.IChartData;
	//HHS 
	//HHS Options
	const hhsOptions: any[] = [];
	dataForFilters?.overall.level1.hhses.map(p => {
		hhsOptions.push({ label: p.name, value: p.id });
	})

	//Filtered HHSes
	let hhsSelections: any[] = [];
	state.page.dashboard.filters?.HHS?.value?.map(p => {
		hhsSelections.push({ label: p, value: hhsOptions.find(a => a.label == p).value });
	})

	//Add code to be able to filter list of facilities to a chosen HHS
	let selectedHHSIds = [];
	if (hhsSelections.length > 0) {
		selectedHHSIds = hhsSelections.map(a =>
			a.value);
	}

	//Facility 
	//Facility Options
	const facilityOptions: any[] = [];
	if (hhsSelections.length > 0) {
		dataForFilters?.overall.level1.facilities.filter(a => selectedHHSIds.includes(a.hhsId)).map(p => {
			facilityOptions.push({ label: p.name, value: p.facilityId });
		})
	} else {
		dataForFilters?.overall.level1.facilities.map(p => {
			facilityOptions.push({ label: p.name, value: p.facilityId });
		});
	}

	//Filtered facilities
	let facilitySelections: any[] = [];
	state.page.dashboard.filters?.Facility?.value?.map(p => {
		facilitySelections.push({ label: p, value: facilityOptions.find(a => a.label == p).value });
	})

	//Add code to be able to filter list of Mdts to a chosen Facilities
	let selectedFacilityIds = [];
	if (facilitySelections.length > 0) {
		selectedFacilityIds = facilitySelections.map(a =>
			a.value);
	}

	//MDTs
	//Options
	const mdtOptions: any[] = [];
	if (facilitySelections.length > 0) {
		dataForFilters?.overall.level1.mdts.filter(a => selectedFacilityIds.includes(a.facilityId)).map(p => {
			mdtOptions.push({ label: p.nameAndFacility, value: p.mdtNameId });
		})
	} else {
		dataForFilters?.overall.level1.mdts.map(p => {
			mdtOptions.push({ label: p.nameAndFacility, value: p.mdtNameId });
		})
	}

	//Filtered MDTs
	let mdtSelections: any[] = [];
	state.page.dashboard.filters?.Mdt?.value?.map(p => {
		mdtSelections.push({ label: p, value: mdtOptions.find(a => a.label == p).value });
	})

	//let { path } = state.page.dashboard.chartData.reviewsByPeriod;
	//let parts = FilterContext.fromPath(path).parts;

	//Months
	//Options
	const monthOptions: any[] = [];
	dataForFilters?.overall.level1.month.map(p => {
		monthOptions.push({ label: p.name, value: p.id });
	})

	//Filtered MDT months
	let mdtMonthSelections: any[] = [];
	state.page.dashboard.filters?.MdtMonth?.value?.map(p => {
		mdtMonthSelections.push({
			label: p,
			value: monthOptions.find(a => a.label == p)?.value
		});
	})

	//Filtered diagnosis months
	let diagMonthSelections: any[] = [];
	state.page.dashboard.filters?.DiagnosisMonth?.value?.map(p => {
		diagMonthSelections.push({ label: p, value: monthOptions.find(a => a.label == p).value });
	})

	//Years
	//MDT Year options
	const mdtYearOptions: any[] = [];
	dataForFilters?.overall.level1.year.map(p => {
		if (p.id >= 2010) {
			mdtYearOptions.push({ label: p.name, value: p.id });
		}
	})

	//Diagnosis year options
	const diagYearOptions: any[] = [];
	dataForFilters?.overall.level1.year.map(p => {
		diagYearOptions.push({ label: p.name, value: p.id });
	})

	//Filtered year selections
	let mdtYearSelections: any[] = [];
	state.page.dashboard.filters?.MdtYear?.value?.map(p => {
		mdtYearSelections.push({
			label: p,
			value: mdtYearOptions.find(a => a.label == p)?.value
		});
	})

	//Filtered diagnosis selections
	let diagYearSelections: any[] = [];
	state.page.dashboard.filters?.DiagnosisYear?.value?.map(p => {
		diagYearSelections.push({ label: p, value: diagYearOptions.find(a => a.label == p).value });
	})

	//State for side by side button 
	const [viewBy, setViewBy] = React.useState(diagYearSelections.length > 0 ? "Diagnosis Year" : "MDT Year");

	return (
		<>
			<Box>
				<Typography>HHS</Typography>
				<Select
					isMulti={true}
					value={hhsSelections}
					options={hhsOptions}
					onChange={p => {
						const selected: any = p;
						let filterValues: string[] = [];
						selected.forEach(a => filterValues.push(a.label));

						if (filterValues.length == 0) {
							removeFilter(HAN.DashboardFilterKeys.HHS.key);
						} else {
							addFilter(HAN.DashboardFilterKeys.HHS.key, filterValues);
						}
					}}
					placeholder={"All"}
					closeMenuOnSelect={false}
					styles={{
						placeholder: (base) => ({
							...base,
							color: "black",
						}),
					}}
				/>
			</Box>


			<Box>
				<Typography>Facility</Typography>
				<Select
					isMulti={true}
					value={facilitySelections}
					options={facilityOptions}
					onChange={p => {
						const selected: any = p;
						let filterValues: string[] = [];
						selected.forEach(a => filterValues.push(a.label));

						if (filterValues.length == 0) {
							removeFilter(HAN.DashboardFilterKeys.Facility.key);
						} else {
							addFilter(HAN.DashboardFilterKeys.Facility.key, filterValues);
						}
					}}
					placeholder={"All"}
					closeMenuOnSelect={false}
					styles={{
						placeholder: (base) => ({
							...base,
							color: "black",
						}),
					}}
				/>
			</Box>


			<Box>
				<Typography>MDT</Typography>
				<Select
					isMulti={true}
					value={mdtSelections}
					options={mdtOptions}
					onChange={p => {
						const selected: any = p;
						let filterValues: string[] = [];
						selected.forEach(a => filterValues.push(a.label));

						if (filterValues.length == 0) {
							removeFilter(HAN.DashboardFilterKeys.Mdt.key);
						} else {
							addFilter(HAN.DashboardFilterKeys.Mdt.key, filterValues);
						}
					}}
					placeholder={"All"}
					closeMenuOnSelect={false}
					styles={{
						placeholder: (base) => ({
							...base,
							color: "black",
						}),
					}}
				/>
			</Box>

			<Box>
				<Typography>View By</Typography>
				<SideBySideButton
					filterItems={["MDT Year", "Diagnosis Year"]}
					currentState={viewBy}
					onChanged={p => {
						setViewBy(p)
					}}

				/>
			</Box>

			{(viewBy == "MDT Year" ?
				<>
					<Box>
						<Typography>MDT Year</Typography>
						<Select
							isMulti={true}
							value={mdtYearSelections}
							options={mdtYearOptions.reverse()}
							onChange={p => {
								const selected: any = p;
								let filterValues: string[] = [];
								selected.forEach(a => filterValues.push(a.label));

								if (filterValues.length == 0) {
									removeFilter(HAN.DashboardFilterKeys.MdtYear.key);
								} else {
									addFilter(HAN.DashboardFilterKeys.MdtYear.key, filterValues);
								}
							}}
							placeholder={"All"}
							closeMenuOnSelect={false}
							styles={{
								placeholder: (base) => ({
									...base,
									color: "black",
								}),
							}}
						/>
					</Box>

					<Box>
						<Typography>MDT Month</Typography>
						<Select
							isMulti={true}
							value={mdtMonthSelections}
							options={monthOptions}
							onChange={p => {
								const selected: any = p;
								let filterValues: string[] = [];
								selected.forEach(a => filterValues.push(a.label));

								if (filterValues.length == 0) {
									removeFilter(HAN.DashboardFilterKeys.MdtMonth.key);
								} else {
									addFilter(HAN.DashboardFilterKeys.MdtMonth.key, filterValues);
								}
							}}
							placeholder={"All"}
							closeMenuOnSelect={false}
							styles={{
								placeholder: (base) => ({
									...base,
									color: "black",
								}),
							}}
						/>
					</Box>
				</>
				:
				<>
					<Box>
						<Typography>Diagnosis Year</Typography>
						<Select
							isMulti={true}
							value={diagYearSelections}
							options={diagYearOptions.reverse()}
							onChange={p => {
								const selected: any = p;
								let filterValues: string[] = [];
								selected.forEach(a => filterValues.push(a.label));

								if (filterValues.length == 0) {
									removeFilter(HAN.DashboardFilterKeys.DiagnosisYear.key);
								} else {
									addFilter(HAN.DashboardFilterKeys.DiagnosisYear.key, filterValues);
								}
							}}
							placeholder={"All"}
							closeMenuOnSelect={false}
							styles={{
								placeholder: (base) => ({
									...base,
									color: "black",
								}),
							}}
						/>
					</Box>

					<Box>
						<Typography>Diagnosis Month</Typography>
						<Select
							isMulti={true}
							value={diagMonthSelections}
							options={monthOptions}
							onChange={p => {
								const selected: any = p;
								let filterValues: string[] = [];
								selected.forEach(a => filterValues.push(a.label));

								if (filterValues.length == 0) {
									removeFilter(HAN.DashboardFilterKeys.DiagnosisMonth.key);
								} else {
									addFilter(HAN.DashboardFilterKeys.DiagnosisMonth.key, filterValues);
								}
							}}
							placeholder={"All"}
							closeMenuOnSelect={false}
							styles={{
								placeholder: (base) => ({
									...base,
									color: "black",
								}),
							}}
						/>
					</Box>


				</>
			)}

		</>
	)
}

